import esupplyvetApi from "@/api/esupplyvet";
import api from "@/api";
import { useRegisterStore } from "@/stores/register";

function getHttpClient() {
  const registerStore = useRegisterStore();
  const userRole = registerStore.user?.role || "";
  return userRole === "client" ? esupplyvetApi : api;
}

/**
 * Service pour la gestion des rappels
 */
export const remindersService = {
  /**
   * Récupère la liste des rappels de l'utilisateur connecté
   * @returns {Promise} Promesse contenant la liste des rappels
   */
  async getReminders() {
    try {
      const response = await getHttpClient().get("/reminders");
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des rappels:", error);
      throw error;
    }
  },

  /**
   * Récupère un rappel par son ID
   * @param {number|string} id - L'ID du rappel à récupérer
   * @returns {Promise} Promesse contenant les données du rappel
   */
  async getReminder(id) {
    try {
      const response = await getHttpClient().get(`/reminders/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération du rappel:", error);
      throw error;
    }
  },

  /**
   * Crée un nouveau rappel
   * @param {Object} reminderData - Les données du rappel à créer
   * @returns {Promise} Promesse contenant les données du nouveau rappel
   */
  async createReminder(reminderData) {
    try {
      const response = await getHttpClient().post("/reminders", reminderData);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création du rappel:", error);
      throw error;
    }
  },

  /**
   * Met à jour un rappel par son ID
   * @param {number|string} id - L'ID du rappel à mettre à jour
   * @param {Object} reminderData - Les données du rappel à mettre à jour
   * @returns {Promise} Promesse contenant les données mises à jour
   */
  async updateReminder(id, reminderData) {
    try {
      const response = await getHttpClient().put(`/reminders/${id}`, reminderData);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour du rappel:", error);
      throw error;
    }
  },

  /**
   * Supprime un rappel par son ID
   * @param {number|string} id - L'ID du rappel à supprimer
   * @returns {Promise} Promesse de suppression
   */
  async deleteReminder(id) {
    try {
      const response = await getHttpClient().delete(`/reminders/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la suppression du rappel:", error);
      throw error;
    }
  },
};
